var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElcashBgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8421 86.795L49.9624 57.8532H31.8209L56.2351 14.9628L52.0533 44.0889H70.1948L45.8421 86.795ZM15.1552 87.2251L22.9653 73.5223C17.5536 66.7016 14.5403 57.9146 15.1552 48.5132C16.5082 28.5427 33.8503 13.4266 53.8367 14.7784C54.6362 14.8399 55.4356 14.9013 56.1736 15.0242L63.7992 1.62866C41.7834 -4.08596 17.9226 5.49986 6.42271 26.2691C-4.95419 46.7312 -0.710916 71.6174 15.1552 87.2251ZM86.6145 14.5327L79.1734 27.6824C84.9541 34.626 88.2134 43.7202 87.5984 53.429C86.2455 73.3994 68.9034 88.5155 48.917 87.1637C47.81 87.1022 46.7646 86.9793 45.7191 86.795L38.0321 100.313C60.0479 106.151 84.0931 96.5652 95.6545 75.7344C106.97 55.1495 102.665 30.1403 86.6145 14.5327Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.9881,
    y1: -0.870781,
    x2: 50.9881,
    y2: 100.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2686,
    stopColor: "#F7CE03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#EFBC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A416"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElcashBgLogoMobile);
export default __webpack_public_path__ + "static/media/elcash-bg-logo-mobile.41fdc836.svg";
export { ForwardRef as ReactComponent };